export const ADD_USERS_TEXT = 'Plan to Add Users'
export const DROPDOWN_DEFAULT_LABEL = 'Prepare to Launch'
export const DROPDOWN_NAME = 'Select a Step'
export const GET_STARTED_BUTTON_TEXT = 'Get Started'
export const GET_STARTED_BUTTON_TEST_ID = 'get-started-button'
export const GOALS_TEXT = 'Add Goals'
export const HOST_TEXT = 'Host All-Staff'
export const IMPLEMENTATION_APPROACH_TEXT = 'Choose Approach'
export const INFORM_TEXT = 'Inform Families'
export const MARK_COMPLETE_BUTTON_TEXT = 'Mark Complete'
export const PAGE_CONTENT_TEST_ID = 'playbook-steps-page-content'
export const PREPARE_TEXT = 'Prep for All-Staff'
export const PROGRAM_START_DATE_TEXT = 'Set Start Date'
export const PURPOSE_TEXT = 'Add Your Purpose'
export const RESUME_BUTTON_TEXT = 'Resume'
export const SUMMARY_TEXT = 'View Summary'
